(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shark-drop-singolo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop-singolo')) {
    customElements.define('shark-drop-singolo', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.events = { signal: this.controller.signal };
        this.form = this.querySelector('product-form form');
        this.form?.querySelector('.product-variant-id')?.removeAttribute('disabled');
        // App blocks can sit anywhere in the column: keep their fields part of the product form payload.
        if (this.form?.id) this.querySelectorAll('.sds-app input, .sds-app select, .sds-app textarea').forEach(field => { if (!field.form && !field.hasAttribute('form')) field.setAttribute('form', this.form.id); });
        this.radios = [...this.querySelectorAll('input[data-variant]')];
        this.initialVariantId = this.selected()?.value;
        this.quantity = this.querySelector('[data-quantity]');
        this.sticky = this.querySelector('[data-sticky]');
        this.busy = false;
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'it', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.querySelectorAll('[data-quantity-minus],[data-quantity-plus],[data-gallery-controls]').forEach(el => el.hidden = false);
        this.setupGallery();
        if (!this.form || !this.quantity) return;
        this.addEventListener('change', event => {
          if (event.target.matches('input[data-variant]')) { if (this.nativeForm) this.nativeForm.error = false; this.update(true); this.clearFeedback(); }
        }, this.events);
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('input[data-variant]')) {
            event.preventDefault();
            if (!event.target.checked) { event.target.checked = true; event.target.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        }, this.events);
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(-1); }, this.events);
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(1); }, this.events);
        this.querySelector('[data-sticky-add]')?.addEventListener('click', () => { if (!this.busy) this.form.requestSubmit(this.querySelector('[data-native-submit]')); }, this.events);
        const lifecycleSignal = this.controller.signal;
        customElements.whenDefined('product-form').then(() => {
          if (!this.isConnected || lifecycleSignal.aborted) return;
          this.nativeForm = this.querySelector('product-form');
          this.nativeSubmit = this.querySelector('[data-native-submit]');
          this.cartObserver = new MutationObserver(() => this.syncCartState());
          this.cartObserver.observe(this.nativeSubmit, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
          this.update(false);
          this.syncCartState();
        });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          const choice = this.radios.find(radio => radio.value === (id || this.initialVariantId));
          if (choice) { choice.checked = true; this.update(false); this.showVariantMedia(choice); this.clearFeedback(); }
        }, this.events);
        this.update(false);
        const actions = this.querySelector('[data-primary-actions]');
        if (this.sticky && actions && this.dataset.designMode !== 'true') {
          this.syncStickyHeight = () => {
            if (!this.sticky.hidden) document.body.style.setProperty('--sds-sticky-height', `${this.sticky.offsetHeight}px`);
          };
          if ('ResizeObserver' in window) {
            this.stickyResizeObserver = new ResizeObserver(this.syncStickyHeight);
            this.stickyResizeObserver.observe(this.sticky);
          }
          this.syncSticky = () => {
            const show = actions.getBoundingClientRect().bottom < 0;
            this.sticky.hidden = !show;
            document.body.classList.toggle('sds-has-sticky', show);
            this.syncStickyHeight();
          };
          const queueSticky = () => { cancelAnimationFrame(this.stickyFrame); this.stickyFrame = requestAnimationFrame(this.syncSticky); };
          window.addEventListener('scroll', queueSticky, { ...this.events, passive: true });
          window.addEventListener('resize', queueSticky, this.events);
          if ('IntersectionObserver' in window) { this.observer = new IntersectionObserver(this.syncSticky); this.observer.observe(actions); }
          this.syncSticky();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.cartObserver?.disconnect();
        this.stickyResizeObserver?.disconnect();
        cancelAnimationFrame(this.stickyFrame);
        document.body.classList.remove('sds-has-sticky');
        document.body.style.removeProperty('--sds-sticky-height');
      }
      selected() { return this.radios.find(input => input.checked); }
      isDisabled(element) { return !element || element.getAttribute('aria-disabled') === 'true'; }
      setDisabled(element, state) {
        if (!element) return;
        const value = String(Boolean(state));
        if (element.getAttribute('aria-disabled') !== value) element.setAttribute('aria-disabled', value);
      }
      step(direction) {
        const selected = this.selected();
        const step = Number(selected?.dataset.step || 1);
        this.quantity.value = Number(this.quantity.value) + direction * step;
        this.update();
        const value = this.querySelector('[data-quantity-value]');
        if (value && !matchMedia('(prefers-reduced-motion: reduce)').matches) { value.classList.remove('bump'); void value.offsetWidth; value.classList.add('bump'); }
      }
      update(updateUrl = false) {
        const selected = this.selected();
        const locked = this.busy;
        const available = selected && selected.dataset.available === 'true' && this.dataset.planRequired !== 'true';
        const minimum = Number(selected?.dataset.min || 1);
        const step = Number(selected?.dataset.step || 1);
        const maximum = selected?.dataset.max !== '' ? Number(selected?.dataset.max ?? Infinity) : Infinity;
        let amount = Number(this.quantity.value);
        amount = Number.isFinite(amount) ? Math.max(minimum, minimum + Math.round((amount - minimum) / step) * step) : minimum;
        if (Number.isFinite(maximum) && maximum >= minimum) amount = Math.min(amount, minimum + Math.floor((maximum - minimum) / step) * step);
        this.quantity.value = amount;
        this.querySelectorAll('[data-quantity-value]').forEach(el => { if (el.textContent !== String(amount)) el.textContent = amount; });
        const variantInput = this.form.querySelector('.product-variant-id');
        if (variantInput.value !== selected?.value) {
          variantInput.value = selected?.value || '';
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const ticketTemplate = this.querySelector(`[data-tickets-for="${selected?.value}"]`);
        const ticketOutput = this.querySelector('[data-existing-tickets]');
        if (ticketOutput && ticketTemplate && ticketOutput.dataset.variant !== selected.value) {
          ticketOutput.replaceChildren(ticketTemplate.content.cloneNode(true));
          ticketOutput.dataset.variant = selected.value;
        }
        const ticketNumber = ticketOutput ? ticketOutput.querySelector('.cus_ticket') : null;
        const ticketBase = ticketNumber ? Number(ticketNumber.dataset.ticket) : Number(selected?.dataset.ticket || 0);
        const hasTickets = Number.isFinite(ticketBase) && ticketBase > 0;
        if (ticketNumber) ticketNumber.textContent = ticketBase * amount;
        this.querySelectorAll('[data-ticket-wrap]').forEach(el => el.hidden = !hasTickets);
        this.querySelectorAll('[data-ticket-total]').forEach(el => el.textContent = hasTickets ? ticketBase * amount : '');
        this.querySelectorAll('[data-ticket-text]').forEach(el => el.textContent = selected?.dataset.ticketText || '');
        this.setDisabled(this.querySelector('[data-quantity-minus]'), locked || !available || amount <= minimum);
        this.setDisabled(this.querySelector('[data-quantity-plus]'), locked || !available || amount + step > maximum);
        this.querySelectorAll('[data-total]').forEach(el => el.textContent = this.money(Number(selected?.dataset.price || 0) * amount));
        this.querySelectorAll('[data-selected-name]').forEach(el => el.textContent = selected?.dataset.title || '');
        this.querySelectorAll('[data-add]').forEach(button => {
          if (button.disabled !== !available) button.disabled = !available;
          this.setDisabled(button, locked || !available);
          const label = this.busy ? this.dataset.loading : available ? this.dataset.addLabel : this.dataset.soldOut;
          const text = button.querySelector('[data-add-text]');
          if (text.textContent !== label) text.textContent = label;
        });
        this.querySelectorAll('.shopify-payment-button').forEach(express => {
          express.hidden = !available;
          express.inert = locked;
        });
        if (updateUrl && selected) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
          this.showVariantMedia(selected);
        }
      }
      money(cents) {
        const format = this.moneyFormat;
        const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!token) return this.formatter.format(cents / 100);
        const rules = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_period_and_space_separator: [2, ' ', '.'],
        };
        const [decimals, thousands, decimal] = rules[token[1]] || rules.amount;
        const parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
        const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const output = document.createElement('template');
        output.innerHTML = format.replace(token[0], whole + (parts[1] ? decimal + parts[1] : ''));
        return output.content.textContent;
      }
      clearFeedback() {
        this.querySelectorAll('[data-error-message],[data-status],[data-cart-link]').forEach(el => el.hidden = true);
      }
      showError(message) {
        const wrapper = this.querySelector('[data-error-message]');
        if (!wrapper) return;
        wrapper.querySelector('.product-form__error-message').textContent = message || this.dataset.error;
        wrapper.hidden = false;
      }
      syncCartState() {
        this.busy = this.nativeSubmit.classList.contains('loading');
        this.update();
      }
      setupGallery() {
        this.track = this.querySelector('[data-gallery]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.galleryIndex = 0;
        if (!this.track) return;
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        const dots = this.querySelector('[data-gallery-dots]');
        this.dots = [];
        if (dots && this.slides.length > 1) {
          dots.replaceChildren();
          this.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', (this.dataset.slideLabel || '[index] / [total]').replace('[index]', index + 1).replace('[total]', this.slides.length));
            dot.addEventListener('click', () => this.goTo(index), this.events);
            dots.append(dot);
            this.dots.push(dot);
          });
        }
        this.syncGallery = () => {
          this.galleryIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1))));
          this.thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === this.galleryIndex)));
          this.dots.forEach((dot, index) => { dot.classList.toggle('is-on', index === this.galleryIndex); dot.setAttribute('aria-current', String(index === this.galleryIndex)); });
          this.setDisabled(previous, this.galleryIndex === 0);
          this.setDisabled(next, this.galleryIndex === this.slides.length - 1);
          const thumb = this.thumbs[this.galleryIndex];
          if (thumb) { const row = thumb.parentElement; const left = thumb.offsetLeft - (row.clientWidth - thumb.clientWidth) / 2; if (Math.abs(row.scrollLeft - left) > 4) row.scrollTo({ left, behavior: this.motion() }); }
          this.slides.forEach((slide, index) => { if (index !== this.galleryIndex) slide.querySelectorAll('video').forEach(video => video.pause()); });
        };
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.galleryFrame); this.galleryFrame = requestAnimationFrame(this.syncGallery); }, { ...this.events, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, this.events);
        previous?.addEventListener('click', () => { if (!this.isDisabled(previous)) this.goTo(this.galleryIndex - 1); }, this.events);
        next?.addEventListener('click', () => { if (!this.isDisabled(next)) this.goTo(this.galleryIndex + 1); }, this.events);
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), this.events));
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.galleryIndex, 'auto'));
        this.resizeObserver.observe(this.track);
        this.syncGallery();
        const selected = this.selected();
        if (selected && new URL(window.location.href).searchParams.has('variant')) this.showVariantMedia(selected);
      }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      goTo(index, behavior) {
        if (!this.track) return;
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: behavior || this.motion() });
      }
      showVariantMedia(selected) {
        const index = this.slides.findIndex(slide => slide.dataset.media && slide.dataset.media === selected.dataset.mediaId);
        if (index >= 0) this.goTo(index);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shark-drop-v2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop')) {
    customElements.define('shark-drop', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.events = { signal: this.controller.signal };
        this.form = this.querySelector('product-form form');
        this.form?.querySelector('.product-variant-id')?.removeAttribute('disabled');
        // App blocks can sit anywhere in the column: keep their fields part of the product form payload.
        if (this.form?.id) this.querySelectorAll('.sd-app input, .sd-app select, .sd-app textarea').forEach(field => { if (!field.form && !field.hasAttribute('form')) field.setAttribute('form', this.form.id); });
        this.radios = [...this.querySelectorAll('input[data-variant]')];
        this.initialVariantId = this.selected()?.value;
        this.quantity = this.querySelector('[data-quantity]');
        this.sticky = this.querySelector('[data-sticky]');
        this.busy = false;
        this.buying = false;
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'it', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.querySelectorAll('[data-quantity-minus],[data-quantity-plus],[data-gallery-controls]').forEach(el => el.hidden = false);
        this.setupGallery();
        if (!this.form || !this.quantity) return;
        this.addEventListener('change', event => {
          if (event.target.matches('input[data-variant]')) { if (this.nativeForm) this.nativeForm.error = false; this.update(true); this.clearFeedback(); }
        }, this.events);
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('input[data-variant]')) {
            event.preventDefault();
            if (!event.target.checked) { event.target.checked = true; event.target.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        }, this.events);
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(-1); }, this.events);
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(1); }, this.events);
        this.querySelector('[data-sticky-add]')?.addEventListener('click', () => { if (!this.busy && !this.buying) this.form.requestSubmit(this.querySelector('[data-native-submit]')); }, this.events);
        this.querySelector('[data-buy-now]')?.addEventListener('click', () => this.buyNow(), this.events);
        const lifecycleSignal = this.controller.signal;
        customElements.whenDefined('product-form').then(() => {
          if (!this.isConnected || lifecycleSignal.aborted) return;
          this.nativeForm = this.querySelector('product-form');
          this.nativeSubmit = this.querySelector('[data-native-submit]');
          this.cartObserver = new MutationObserver(() => this.syncCartState());
          this.cartObserver.observe(this.nativeSubmit, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
          this.update(false);
          this.syncCartState();
        });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          const choice = this.radios.find(radio => radio.value === (id || this.initialVariantId));
          if (choice) { choice.checked = true; this.update(false); this.showVariantMedia(choice); this.clearFeedback(); }
        }, this.events);
        window.addEventListener('pageshow', event => {
          if (event.persisted && this.buying) this.unlockBuyNow();
        }, this.events);
        this.update(false);
        const actions = this.querySelector('[data-primary-actions]');
        if (this.sticky && actions && this.dataset.designMode !== 'true') {
          this.syncSticky = () => {
            const show = actions.getBoundingClientRect().bottom < 0;
            this.sticky.hidden = !show;
            document.body.classList.toggle('sd-has-sticky', show);
          };
          const queueSticky = () => { cancelAnimationFrame(this.stickyFrame); this.stickyFrame = requestAnimationFrame(this.syncSticky); };
          window.addEventListener('scroll', queueSticky, { ...this.events, passive: true });
          window.addEventListener('resize', queueSticky, this.events);
          if ('IntersectionObserver' in window) { this.observer = new IntersectionObserver(this.syncSticky); this.observer.observe(actions); }
          this.syncSticky();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.cartObserver?.disconnect();
        cancelAnimationFrame(this.stickyFrame);
        document.body.classList.remove('sd-has-sticky');
      }
      selected() { return this.radios.find(input => input.checked); }
      isDisabled(element) { return !element || element.getAttribute('aria-disabled') === 'true'; }
      setDisabled(element, state) {
        if (!element) return;
        const value = String(Boolean(state));
        if (element.getAttribute('aria-disabled') !== value) element.setAttribute('aria-disabled', value);
      }
      step(direction) {
        const selected = this.selected();
        const step = Number(selected?.dataset.step || 1);
        this.quantity.value = Number(this.quantity.value) + direction * step;
        this.update();
        const value = this.querySelector('[data-quantity-value]');
        if (value && !matchMedia('(prefers-reduced-motion: reduce)').matches) { value.classList.remove('bump'); void value.offsetWidth; value.classList.add('bump'); }
      }
      update(updateUrl = false) {
        const selected = this.selected();
        const locked = this.busy || this.buying;
        const available = selected && selected.dataset.available === 'true' && this.dataset.planRequired !== 'true';
        const minimum = Number(selected?.dataset.min || 1);
        const step = Number(selected?.dataset.step || 1);
        const maximum = selected?.dataset.max !== '' ? Number(selected?.dataset.max ?? Infinity) : Infinity;
        let amount = Number(this.quantity.value);
        amount = Number.isFinite(amount) ? Math.max(minimum, minimum + Math.round((amount - minimum) / step) * step) : minimum;
        if (Number.isFinite(maximum) && maximum >= minimum) amount = Math.min(amount, minimum + Math.floor((maximum - minimum) / step) * step);
        this.quantity.value = amount;
        this.querySelectorAll('[data-quantity-value]').forEach(el => { if (el.textContent !== String(amount)) el.textContent = amount; });
        const variantInput = this.form.querySelector('.product-variant-id');
        if (variantInput.value !== selected?.value) {
          variantInput.value = selected?.value || '';
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const ticketTemplate = this.querySelector(`[data-tickets-for="${selected?.value}"]`);
        const ticketOutput = this.querySelector('[data-existing-tickets]');
        if (ticketOutput && ticketTemplate && ticketOutput.dataset.variant !== selected.value) {
          ticketOutput.replaceChildren(ticketTemplate.content.cloneNode(true));
          ticketOutput.dataset.variant = selected.value;
        }
        const ticketNumber = ticketOutput ? ticketOutput.querySelector('.cus_ticket') : null;
        const ticketBase = ticketNumber ? Number(ticketNumber.dataset.ticket) : Number(selected?.dataset.ticket || 0);
        const hasTickets = Number.isFinite(ticketBase) && ticketBase > 0;
        if (ticketNumber) ticketNumber.textContent = ticketBase * amount;
        this.querySelectorAll('[data-ticket-wrap]').forEach(el => el.hidden = !hasTickets);
        this.querySelectorAll('[data-ticket-total]').forEach(el => el.textContent = hasTickets ? ticketBase * amount : '');
        this.setDisabled(this.querySelector('[data-quantity-minus]'), locked || !available || amount <= minimum);
        this.setDisabled(this.querySelector('[data-quantity-plus]'), locked || !available || amount + step > maximum);
        this.querySelectorAll('[data-total]').forEach(el => el.textContent = this.money(Number(selected?.dataset.price || 0) * amount));
        this.querySelectorAll('[data-selected-name]').forEach(el => el.textContent = selected?.dataset.title || '');
        this.querySelectorAll('[data-add]').forEach(button => {
          if (button.disabled !== !available) button.disabled = !available;
          this.setDisabled(button, locked || !available);
          const label = this.busy ? this.dataset.loading : available ? this.dataset.addLabel : this.dataset.soldOut;
          const text = button.querySelector('[data-add-text]');
          if (text.textContent !== label) text.textContent = label;
        });
        const buyNow = this.querySelector('[data-buy-now]');
        if (buyNow) { if (buyNow.disabled !== !available) buyNow.disabled = !available; this.setDisabled(buyNow, locked || !available); buyNow.setAttribute('aria-busy', String(this.buying)); }
        const express = this.querySelector('[data-express]');
        if (express) { express.hidden = !available; express.inert = locked; }
        if (updateUrl && selected) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
          this.showVariantMedia(selected);
        }
      }
      money(cents) {
        const format = this.moneyFormat;
        const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!token) return this.formatter.format(cents / 100);
        const rules = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_period_and_space_separator: [2, ' ', '.'],
        };
        const [decimals, thousands, decimal] = rules[token[1]] || rules.amount;
        const parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
        const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const output = document.createElement('template');
        output.innerHTML = format.replace(token[0], whole + (parts[1] ? decimal + parts[1] : ''));
        return output.content.textContent;
      }
      clearFeedback() {
        this.querySelectorAll('[data-error-message],[data-status],[data-cart-link]').forEach(el => el.hidden = true);
      }
      showError(message) {
        const wrapper = this.querySelector('[data-error-message]');
        if (!wrapper) return;
        wrapper.querySelector('.product-form__error-message').textContent = message || this.dataset.error;
        wrapper.hidden = false;
      }
      syncCartState() {
        this.busy = this.nativeSubmit.classList.contains('loading');
        this.update();
      }
      buyNow() {
        const selected = this.selected();
        if (this.busy || this.buying || !selected || selected.dataset.available !== 'true') return;
        this.clearFeedback();
        this.buying = true;
        this.update();
        const body = new FormData(this.form);
        fetch(this.dataset.cartAddUrl || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body })
          .then(response => response.json().catch(() => ({ status: response.status || 500 })))
          .then(response => {
            if (response.status) throw Object.assign(new Error(response.description || response.message || this.dataset.error), { shopper: true });
            window.location.href = this.dataset.checkoutUrl || '/checkout';
          })
          .catch(error => {
            this.unlockBuyNow();
            this.showError(error.shopper ? error.message : this.dataset.error);
          });
      }
      unlockBuyNow() {
        this.buying = false;
        this.update();
      }
      setupGallery() {
        this.track = this.querySelector('[data-gallery]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.galleryIndex = 0;
        if (!this.track) return;
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        const dots = this.querySelector('[data-gallery-dots]');
        this.dots = [];
        if (dots && this.slides.length > 1) {
          dots.replaceChildren();
          this.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', (this.dataset.slideLabel || '[index] / [total]').replace('[index]', index + 1).replace('[total]', this.slides.length));
            dot.addEventListener('click', () => this.goTo(index), this.events);
            dots.append(dot);
            this.dots.push(dot);
          });
        }
        this.syncGallery = () => {
          this.galleryIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1))));
          this.thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === this.galleryIndex)));
          this.dots.forEach((dot, index) => { dot.classList.toggle('is-on', index === this.galleryIndex); dot.setAttribute('aria-current', String(index === this.galleryIndex)); });
          this.setDisabled(previous, this.galleryIndex === 0);
          this.setDisabled(next, this.galleryIndex === this.slides.length - 1);
          const thumb = this.thumbs[this.galleryIndex];
          if (thumb) { const row = thumb.parentElement; const left = thumb.offsetLeft - (row.clientWidth - thumb.clientWidth) / 2; if (Math.abs(row.scrollLeft - left) > 4) row.scrollTo({ left, behavior: this.motion() }); }
          this.slides.forEach((slide, index) => { if (index !== this.galleryIndex) slide.querySelectorAll('video').forEach(video => video.pause()); });
        };
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.galleryFrame); this.galleryFrame = requestAnimationFrame(this.syncGallery); }, { ...this.events, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, this.events);
        previous?.addEventListener('click', () => { if (!this.isDisabled(previous)) this.goTo(this.galleryIndex - 1); }, this.events);
        next?.addEventListener('click', () => { if (!this.isDisabled(next)) this.goTo(this.galleryIndex + 1); }, this.events);
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), this.events));
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.galleryIndex, 'auto'));
        this.resizeObserver.observe(this.track);
        this.syncGallery();
        const selected = this.selected();
        if (selected && new URL(window.location.href).searchParams.has('variant')) this.showVariantMedia(selected);
      }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      goTo(index, behavior) {
        if (!this.track) return;
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: behavior || this.motion() });
      }
      showVariantMedia(selected) {
        const index = this.slides.findIndex(slide => slide.dataset.media && slide.dataset.media === selected.dataset.mediaId);
        if (index >= 0) this.goTo(index);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-shark-drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop')) {
    customElements.define('shark-drop', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.events = { signal: this.controller.signal };
        this.form = this.querySelector('product-form form');
        this.form?.querySelector('.product-variant-id')?.removeAttribute('disabled');
        // App blocks can sit anywhere in the column: keep their fields part of the product form payload.
        if (this.form?.id) this.querySelectorAll('.sd-app input, .sd-app select, .sd-app textarea').forEach(field => { if (!field.form && !field.hasAttribute('form')) field.setAttribute('form', this.form.id); });
        this.radios = [...this.querySelectorAll('input[data-variant]')];
        this.initialVariantId = this.selected()?.value;
        this.quantity = this.querySelector('[data-quantity]');
        this.sticky = this.querySelector('[data-sticky]');
        this.busy = false;
        this.moneyFormat = this.dataset.moneyFormat || '';
        this.formatter = new Intl.NumberFormat(this.dataset.locale || 'it', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.querySelectorAll('[data-quantity-minus],[data-quantity-plus],[data-gallery-controls]').forEach(el => el.hidden = false);
        this.setupGallery();
        if (!this.form || !this.quantity) return;
        this.addEventListener('change', event => {
          if (event.target.matches('input[data-variant]')) { if (this.nativeForm) this.nativeForm.error = false; this.update(true); this.clearFeedback(); }
        }, this.events);
        this.addEventListener('keydown', event => {
          if (event.key === 'Enter' && event.target.matches('input[data-variant]')) {
            event.preventDefault();
            if (!event.target.checked) { event.target.checked = true; event.target.dispatchEvent(new Event('change', { bubbles: true })); }
          }
        }, this.events);
        this.querySelector('[data-quantity-minus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(-1); }, this.events);
        this.querySelector('[data-quantity-plus]')?.addEventListener('click', event => { if (!this.isDisabled(event.currentTarget)) this.step(1); }, this.events);
        this.querySelector('[data-sticky-add]')?.addEventListener('click', () => { if (!this.busy) this.form.requestSubmit(this.querySelector('[data-native-submit]')); }, this.events);
        const lifecycleSignal = this.controller.signal;
        customElements.whenDefined('product-form').then(() => {
          if (!this.isConnected || lifecycleSignal.aborted) return;
          this.nativeForm = this.querySelector('product-form');
          this.nativeSubmit = this.querySelector('[data-native-submit]');
          this.cartObserver = new MutationObserver(() => this.syncCartState());
          this.cartObserver.observe(this.nativeSubmit, { attributes: true, attributeFilter: ['class', 'aria-disabled', 'disabled'] });
          this.update(false);
          this.syncCartState();
        });
        window.addEventListener('popstate', () => {
          const id = new URL(window.location.href).searchParams.get('variant');
          const choice = this.radios.find(radio => radio.value === (id || this.initialVariantId));
          if (choice) { choice.checked = true; this.update(false); this.showVariantMedia(choice); this.clearFeedback(); }
        }, this.events);
        this.update(false);
        const actions = this.querySelector('[data-primary-actions]');
        if (this.sticky && actions && this.dataset.designMode !== 'true') {
          this.syncStickyHeight = () => {
            if (!this.sticky.hidden) document.body.style.setProperty('--sd-sticky-height', `${this.sticky.offsetHeight}px`);
          };
          if ('ResizeObserver' in window) {
            this.stickyResizeObserver = new ResizeObserver(this.syncStickyHeight);
            this.stickyResizeObserver.observe(this.sticky);
          }
          this.syncSticky = () => {
            const show = actions.getBoundingClientRect().bottom < 0;
            this.sticky.hidden = !show;
            document.body.classList.toggle('sd-has-sticky', show);
            this.syncStickyHeight();
          };
          const queueSticky = () => { cancelAnimationFrame(this.stickyFrame); this.stickyFrame = requestAnimationFrame(this.syncSticky); };
          window.addEventListener('scroll', queueSticky, { ...this.events, passive: true });
          window.addEventListener('resize', queueSticky, this.events);
          if ('IntersectionObserver' in window) { this.observer = new IntersectionObserver(this.syncSticky); this.observer.observe(actions); }
          this.syncSticky();
        }
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.resizeObserver?.disconnect();
        this.cartObserver?.disconnect();
        this.stickyResizeObserver?.disconnect();
        cancelAnimationFrame(this.stickyFrame);
        document.body.classList.remove('sd-has-sticky');
        document.body.style.removeProperty('--sd-sticky-height');
      }
      selected() { return this.radios.find(input => input.checked); }
      isDisabled(element) { return !element || element.getAttribute('aria-disabled') === 'true'; }
      setDisabled(element, state) {
        if (!element) return;
        const value = String(Boolean(state));
        if (element.getAttribute('aria-disabled') !== value) element.setAttribute('aria-disabled', value);
      }
      step(direction) {
        const selected = this.selected();
        const step = Number(selected?.dataset.step || 1);
        this.quantity.value = Number(this.quantity.value) + direction * step;
        this.update();
        const value = this.querySelector('[data-quantity-value]');
        if (value && !matchMedia('(prefers-reduced-motion: reduce)').matches) { value.classList.remove('bump'); void value.offsetWidth; value.classList.add('bump'); }
      }
      update(updateUrl = false) {
        const selected = this.selected();
        const locked = this.busy;
        const available = selected && selected.dataset.available === 'true' && this.dataset.planRequired !== 'true';
        const minimum = Number(selected?.dataset.min || 1);
        const step = Number(selected?.dataset.step || 1);
        const maximum = selected?.dataset.max !== '' ? Number(selected?.dataset.max ?? Infinity) : Infinity;
        let amount = Number(this.quantity.value);
        amount = Number.isFinite(amount) ? Math.max(minimum, minimum + Math.round((amount - minimum) / step) * step) : minimum;
        if (Number.isFinite(maximum) && maximum >= minimum) amount = Math.min(amount, minimum + Math.floor((maximum - minimum) / step) * step);
        this.quantity.value = amount;
        this.querySelectorAll('[data-quantity-value]').forEach(el => { if (el.textContent !== String(amount)) el.textContent = amount; });
        const variantInput = this.form.querySelector('.product-variant-id');
        if (variantInput.value !== selected?.value) {
          variantInput.value = selected?.value || '';
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
        const ticketTemplate = this.querySelector(`[data-tickets-for="${selected?.value}"]`);
        const ticketOutput = this.querySelector('[data-existing-tickets]');
        if (ticketOutput && ticketTemplate && ticketOutput.dataset.variant !== selected.value) {
          ticketOutput.replaceChildren(ticketTemplate.content.cloneNode(true));
          ticketOutput.dataset.variant = selected.value;
        }
        const ticketNumber = ticketOutput ? ticketOutput.querySelector('.cus_ticket') : null;
        const ticketBase = ticketNumber ? Number(ticketNumber.dataset.ticket) : Number(selected?.dataset.ticket || 0);
        const hasTickets = Number.isFinite(ticketBase) && ticketBase > 0;
        if (ticketNumber) ticketNumber.textContent = ticketBase * amount;
        this.querySelectorAll('[data-ticket-wrap]').forEach(el => el.hidden = !hasTickets);
        this.querySelectorAll('[data-ticket-total]').forEach(el => el.textContent = hasTickets ? ticketBase * amount : '');
        this.querySelectorAll('[data-ticket-text]').forEach(el => el.textContent = selected?.dataset.ticketText || '');
        this.setDisabled(this.querySelector('[data-quantity-minus]'), locked || !available || amount <= minimum);
        this.setDisabled(this.querySelector('[data-quantity-plus]'), locked || !available || amount + step > maximum);
        this.querySelectorAll('[data-total]').forEach(el => el.textContent = this.money(Number(selected?.dataset.price || 0) * amount));
        this.querySelectorAll('[data-selected-name]').forEach(el => el.textContent = selected?.dataset.title || '');
        this.querySelectorAll('[data-add]').forEach(button => {
          if (button.disabled !== !available) button.disabled = !available;
          this.setDisabled(button, locked || !available);
          const label = this.busy ? this.dataset.loading : available ? this.dataset.addLabel : this.dataset.soldOut;
          const text = button.querySelector('[data-add-text]');
          if (text.textContent !== label) text.textContent = label;
        });
        this.querySelectorAll('.shopify-payment-button').forEach(express => {
          express.hidden = !available;
          express.inert = locked;
        });
        if (updateUrl && selected) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', selected.value);
          window.history.replaceState({}, '', url);
          this.showVariantMedia(selected);
        }
      }
      money(cents) {
        const format = this.moneyFormat;
        const token = format.match(/\{\{\s*(\w+)\s*\}\}/);
        if (!token) return this.formatter.format(cents / 100);
        const rules = {
          amount: [2, ',', '.'],
          amount_no_decimals: [0, ',', '.'],
          amount_with_comma_separator: [2, '.', ','],
          amount_no_decimals_with_comma_separator: [0, '.', ','],
          amount_with_apostrophe_separator: [2, "'", '.'],
          amount_with_space_separator: [2, ' ', ','],
          amount_no_decimals_with_space_separator: [0, ' ', ','],
          amount_with_period_and_space_separator: [2, ' ', '.'],
        };
        const [decimals, thousands, decimal] = rules[token[1]] || rules.amount;
        const parts = (Math.round(cents) / 100).toFixed(decimals).split('.');
        const whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
        const output = document.createElement('template');
        output.innerHTML = format.replace(token[0], whole + (parts[1] ? decimal + parts[1] : ''));
        return output.content.textContent;
      }
      clearFeedback() {
        this.querySelectorAll('[data-error-message],[data-status],[data-cart-link]').forEach(el => el.hidden = true);
      }
      showError(message) {
        const wrapper = this.querySelector('[data-error-message]');
        if (!wrapper) return;
        wrapper.querySelector('.product-form__error-message').textContent = message || this.dataset.error;
        wrapper.hidden = false;
      }
      syncCartState() {
        this.busy = this.nativeSubmit.classList.contains('loading');
        this.update();
      }
      setupGallery() {
        this.track = this.querySelector('[data-gallery]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbs = [...this.querySelectorAll('[data-thumb]')];
        this.galleryIndex = 0;
        if (!this.track) return;
        const previous = this.querySelector('[data-gallery-prev]');
        const next = this.querySelector('[data-gallery-next]');
        const dots = this.querySelector('[data-gallery-dots]');
        this.dots = [];
        if (dots && this.slides.length > 1) {
          dots.replaceChildren();
          this.slides.forEach((slide, index) => {
            const dot = document.createElement('button');
            dot.type = 'button';
            dot.setAttribute('aria-label', (this.dataset.slideLabel || '[index] / [total]').replace('[index]', index + 1).replace('[total]', this.slides.length));
            dot.addEventListener('click', () => this.goTo(index), this.events);
            dots.append(dot);
            this.dots.push(dot);
          });
        }
        this.syncGallery = () => {
          this.galleryIndex = Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / Math.max(this.track.clientWidth, 1))));
          this.thumbs.forEach((button, index) => button.setAttribute('aria-current', String(index === this.galleryIndex)));
          this.dots.forEach((dot, index) => { dot.classList.toggle('is-on', index === this.galleryIndex); dot.setAttribute('aria-current', String(index === this.galleryIndex)); });
          this.setDisabled(previous, this.galleryIndex === 0);
          this.setDisabled(next, this.galleryIndex === this.slides.length - 1);
          const thumb = this.thumbs[this.galleryIndex];
          if (thumb) { const row = thumb.parentElement; const left = thumb.offsetLeft - (row.clientWidth - thumb.clientWidth) / 2; if (Math.abs(row.scrollLeft - left) > 4) row.scrollTo({ left, behavior: this.motion() }); }
          this.slides.forEach((slide, index) => { if (index !== this.galleryIndex) slide.querySelectorAll('video').forEach(video => video.pause()); });
        };
        this.track.addEventListener('scroll', () => { cancelAnimationFrame(this.galleryFrame); this.galleryFrame = requestAnimationFrame(this.syncGallery); }, { ...this.events, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          this.goTo(event.key === 'Home' ? 0 : event.key === 'End' ? this.slides.length - 1 : this.galleryIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }, this.events);
        previous?.addEventListener('click', () => { if (!this.isDisabled(previous)) this.goTo(this.galleryIndex - 1); }, this.events);
        next?.addEventListener('click', () => { if (!this.isDisabled(next)) this.goTo(this.galleryIndex + 1); }, this.events);
        this.thumbs.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), this.events));
        this.resizeObserver = new ResizeObserver(() => this.goTo(this.galleryIndex, 'auto'));
        this.resizeObserver.observe(this.track);
        this.syncGallery();
        const selected = this.selected();
        if (selected && new URL(window.location.href).searchParams.has('variant')) this.showVariantMedia(selected);
      }
      motion() { return matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
      goTo(index, behavior) {
        if (!this.track) return;
        const target = Math.max(0, Math.min(index, this.slides.length - 1));
        this.track.scrollTo({ left: target * this.track.clientWidth, behavior: behavior || this.motion() });
      }
      showVariantMedia(selected) {
        const index = this.slides.findIndex(slide => slide.dataset.media && slide.dataset.media === selected.dataset.mediaId);
        if (index >= 0) this.goTo(index);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shark-drop-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop-faq')) {
    customElements.define('shark-drop-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.items = [...this.querySelectorAll('details')];
        this.states = new Map();
        this.items.forEach(item => {
          // Native exclusive groups close their siblings immediately; JS animates both directions.
          this.states.set(item, { open: item.open, name: item.getAttribute('name'), animation: null });
          item.removeAttribute('name');
          item.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            const open = !this.states.get(item).open;
            if (open) this.items.forEach(other => {
              if (other !== item && this.states.get(other).open) this.setOpen(other, false);
            });
            this.setOpen(item, open);
          }, { signal: this.controller.signal });
        });
      }
      setOpen(item, open) {
        const state = this.states.get(item);
        const start = item.getBoundingClientRect().height;
        state.animation?.cancel();
        state.open = open;
        const summary = item.querySelector('summary');
        const answer = item.querySelector('.sd-faq-a');
        if (!open && answer.contains(document.activeElement)) summary.focus();
        answer.inert = !open;
        item.toggleAttribute('data-closing', !open);
        const finish = () => {
          item.open = open;
          item.style.height = '';
          item.removeAttribute('data-closing');
          state.animation = null;
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {
          finish();
          return;
        }
        item.style.height = `${start}px`;
        item.open = true;
        const style = getComputedStyle(item);
        const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const end = summary.getBoundingClientRect().height + (open ? answer.getBoundingClientRect().height : 0) + borders;
        const animation = item.animate({ height: [`${start}px`, `${end}px`] }, {
          duration: 260, easing: 'cubic-bezier(.22, 1, .36, 1)'
        });
        state.animation = animation;
        animation.onfinish = () => { if (state.animation === animation) finish(); };
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.states?.forEach((state, item) => {
          state.animation?.cancel();
          item.open = state.open;
          item.style.height = '';
          item.removeAttribute('data-closing');
          if (state.name) item.setAttribute('name', state.name);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shark-drop-singolo-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop-singolo-faq')) {
    customElements.define('shark-drop-singolo-faq', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        this.items = [...this.querySelectorAll('details')];
        this.states = new Map();
        this.items.forEach(item => {
          // Native exclusive groups close their siblings immediately; JS animates both directions.
          this.states.set(item, { open: item.open, name: item.getAttribute('name'), animation: null });
          item.removeAttribute('name');
          item.querySelector('summary').addEventListener('click', event => {
            event.preventDefault();
            const open = !this.states.get(item).open;
            if (open) this.items.forEach(other => {
              if (other !== item && this.states.get(other).open) this.setOpen(other, false);
            });
            this.setOpen(item, open);
          }, { signal: this.controller.signal });
        });
      }
      setOpen(item, open) {
        const state = this.states.get(item);
        const start = item.getBoundingClientRect().height;
        state.animation?.cancel();
        state.open = open;
        const summary = item.querySelector('summary');
        const answer = item.querySelector('.sds-faq-a');
        if (!open && answer.contains(document.activeElement)) summary.focus();
        answer.inert = !open;
        item.toggleAttribute('data-closing', !open);
        const finish = () => {
          item.open = open;
          item.style.height = '';
          item.removeAttribute('data-closing');
          state.animation = null;
        };
        if (matchMedia('(prefers-reduced-motion: reduce)').matches || !item.animate) {
          finish();
          return;
        }
        item.style.height = `${start}px`;
        item.open = true;
        const style = getComputedStyle(item);
        const borders = parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);
        const end = summary.getBoundingClientRect().height + (open ? answer.getBoundingClientRect().height : 0) + borders;
        const animation = item.animate({ height: [`${start}px`, `${end}px`] }, {
          duration: 260, easing: 'cubic-bezier(.22, 1, .36, 1)'
        });
        state.animation = animation;
        animation.onfinish = () => { if (state.animation === animation) finish(); };
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.states?.forEach((state, item) => {
          state.animation?.cancel();
          item.open = state.open;
          item.style.height = '';
          item.removeAttribute('data-closing');
          if (state.name) item.setAttribute('name', state.name);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shark-drop-singolo-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop-singolo-story')) {
    customElements.define('shark-drop-singolo-story', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const events = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.shine === 'true' && !this.reduceMotion.matches) this.classList.add('sds-anim');
        const lane = this.querySelector('[data-cardlane]');
        if (lane && lane.children.length > 1 && !this.reduceMotion.matches) {
          if (!lane.dataset.doubled) {
            lane.dataset.originals = String(lane.children.length);
            [...lane.children].forEach(node => { const copy = node.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); lane.append(copy); });
            lane.dataset.doubled = 'true';
          }
          const originals = Number(lane.dataset.originals) || lane.children.length / 2;
          const period = () => { const first = lane.children[0], clone = lane.children[originals]; return clone && first ? clone.offsetLeft - first.offsetLeft : lane.scrollWidth / 2; };
          const toggle = this.querySelector('[data-lane-toggle]');
          this.lanePaused = false;
          this.laneStopped = toggle?.getAttribute('aria-pressed') === 'true';
          let position = lane.scrollLeft;
          let settle;
          const pause = () => { clearTimeout(settle); this.lanePaused = true; };
          const resume = () => { this.lanePaused = false; position = lane.scrollLeft; };
          // After a touch the lane may still be flinging: resume only once its scroll has settled.
          const settleThenResume = () => { clearTimeout(settle); settle = setTimeout(resume, 180); };
          ['pointerenter', 'touchstart', 'pointerdown', 'focusin'].forEach(name => lane.addEventListener(name, pause, { ...events, passive: true }));
          ['pointerleave', 'focusout'].forEach(name => lane.addEventListener(name, resume, { ...events, passive: true }));
          ['touchend', 'touchcancel'].forEach(name => lane.addEventListener(name, settleThenResume, { ...events, passive: true }));
          lane.addEventListener('scroll', () => { if (this.lanePaused && settle) settleThenResume(); }, { ...events, passive: true });
          if (toggle) {
            toggle.hidden = false;
            toggle.addEventListener('click', () => {
              this.laneStopped = !this.laneStopped;
              if (!this.laneStopped) position = lane.scrollLeft;
              toggle.setAttribute('aria-pressed', String(this.laneStopped));
              toggle.textContent = this.laneStopped ? toggle.dataset.resume : toggle.dataset.pause;
            }, events);
          }
          const marquee = () => {
            if (this.controller.signal.aborted) return;
            if (!this.lanePaused && !this.laneStopped && !this.scrolling && !document.hidden && lane.clientWidth > 0) {
              const loop = period();
              position += 0.6;
              if (loop > 0 && position >= loop) position -= loop;
              lane.scrollLeft = position;
            }
            this.frame = requestAnimationFrame(marquee);
          };
          this.frame = requestAnimationFrame(marquee);
        }
        this.querySelectorAll('[data-go-bundles]').forEach(element => {
          element.addEventListener('click', event => { if (this.goToBundles()) event.preventDefault(); }, events);
        });
      }
      disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame); clearTimeout(this.scrollTimer); this.scrolling = false; }
      goToBundles() {
        const target = document.getElementById('SharkDropSingoloBundles') || document.getElementById('SharkDropSingoloCollections');
        if (!target) return false;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const destination = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - header - 12);
        const focusTarget = () => { const input = target.querySelector('input:checked:not(:disabled)') || target.querySelector('input:not(:disabled)'); (input || target).focus?.({ preventScroll: true }); };
        if (this.reduceMotion.matches) { window.scrollTo(0, destination); focusTarget(); return true; }
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.scrollTimer);
        this.scrolling = true;
        const from = window.pageYOffset, distance = destination - from, duration = 550;
        let started = null;
        const ease = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
        const frame = timestamp => {
          if (started === null) started = timestamp;
          const progress = Math.min(1, (timestamp - started) / duration);
          window.scrollTo(0, from + distance * ease(progress));
          if (progress < 1) this.scrollFrame = requestAnimationFrame(frame); else { this.scrolling = false; focusTarget(); }
        };
        this.scrollFrame = requestAnimationFrame(frame);
        this.scrollTimer = setTimeout(() => { if (Math.abs(window.pageYOffset - destination) > 4) window.scrollTo(0, destination); this.scrolling = false; }, duration + 200);
        return true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shark-drop-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-drop-story')) {
    customElements.define('shark-drop-story', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const events = { signal: this.controller.signal };
        this.reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
        if (this.dataset.shine === 'true' && !this.reduceMotion.matches) this.classList.add('sd-anim');
        const lane = this.querySelector('[data-cardlane]');
        if (lane && lane.children.length > 1 && !this.reduceMotion.matches) {
          if (!lane.dataset.doubled) {
            lane.dataset.originals = String(lane.children.length);
            [...lane.children].forEach(node => { const copy = node.cloneNode(true); copy.setAttribute('aria-hidden', 'true'); lane.append(copy); });
            lane.dataset.doubled = 'true';
          }
          const originals = Number(lane.dataset.originals) || lane.children.length / 2;
          const period = () => { const first = lane.children[0], clone = lane.children[originals]; return clone && first ? clone.offsetLeft - first.offsetLeft : lane.scrollWidth / 2; };
          const toggle = this.querySelector('[data-lane-toggle]');
          this.lanePaused = false;
          this.laneStopped = toggle?.getAttribute('aria-pressed') === 'true';
          let position = lane.scrollLeft;
          let settle;
          const pause = () => { clearTimeout(settle); this.lanePaused = true; };
          const resume = () => { this.lanePaused = false; position = lane.scrollLeft; };
          // After a touch the lane may still be flinging: resume only once its scroll has settled.
          const settleThenResume = () => { clearTimeout(settle); settle = setTimeout(resume, 180); };
          ['pointerenter', 'touchstart', 'pointerdown', 'focusin'].forEach(name => lane.addEventListener(name, pause, { ...events, passive: true }));
          ['pointerleave', 'focusout'].forEach(name => lane.addEventListener(name, resume, { ...events, passive: true }));
          ['touchend', 'touchcancel'].forEach(name => lane.addEventListener(name, settleThenResume, { ...events, passive: true }));
          lane.addEventListener('scroll', () => { if (this.lanePaused && settle) settleThenResume(); }, { ...events, passive: true });
          if (toggle) {
            toggle.hidden = false;
            toggle.addEventListener('click', () => {
              this.laneStopped = !this.laneStopped;
              if (!this.laneStopped) position = lane.scrollLeft;
              toggle.setAttribute('aria-pressed', String(this.laneStopped));
              toggle.textContent = this.laneStopped ? toggle.dataset.resume : toggle.dataset.pause;
            }, events);
          }
          const marquee = () => {
            if (this.controller.signal.aborted) return;
            if (!this.lanePaused && !this.laneStopped && !this.scrolling && !document.hidden && lane.clientWidth > 0) {
              const loop = period();
              position += 0.6;
              if (loop > 0 && position >= loop) position -= loop;
              lane.scrollLeft = position;
            }
            this.frame = requestAnimationFrame(marquee);
          };
          this.frame = requestAnimationFrame(marquee);
        }
        this.querySelectorAll('[data-go-bundles]').forEach(element => {
          element.addEventListener('click', event => { if (this.goToBundles()) event.preventDefault(); }, events);
        });
      }
      disconnectedCallback() { this.controller?.abort(); cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame); clearTimeout(this.scrollTimer); this.scrolling = false; }
      goToBundles() {
        const target = document.getElementById('SharkDropBundles') || document.getElementById('SharkDropCollections');
        if (!target) return false;
        const header = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        const destination = Math.max(0, target.getBoundingClientRect().top + window.pageYOffset - header - 12);
        const focusTarget = () => { const input = target.querySelector('input:checked:not(:disabled)') || target.querySelector('input:not(:disabled)'); (input || target).focus?.({ preventScroll: true }); };
        if (this.reduceMotion.matches) { window.scrollTo(0, destination); focusTarget(); return true; }
        cancelAnimationFrame(this.scrollFrame);
        clearTimeout(this.scrollTimer);
        this.scrolling = true;
        const from = window.pageYOffset, distance = destination - from, duration = 550;
        let started = null;
        const ease = x => x < 0.5 ? 2 * x * x : 1 - Math.pow(-2 * x + 2, 2) / 2;
        const frame = timestamp => {
          if (started === null) started = timestamp;
          const progress = Math.min(1, (timestamp - started) / duration);
          window.scrollTo(0, from + distance * ease(progress));
          if (progress < 1) this.scrollFrame = requestAnimationFrame(frame); else { this.scrolling = false; focusTarget(); }
        };
        this.scrollFrame = requestAnimationFrame(frame);
        this.scrollTimer = setTimeout(() => { if (Math.abs(window.pageYOffset - destination) > 4) window.scrollTo(0, destination); this.scrolling = false; }, duration + 200);
        return true;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shark-password-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('shark-password-launch')) {
    customElements.define('shark-password-launch', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        clearTimeout(this.timer);
        this.controller = new AbortController();
        document.addEventListener('click', event => {
          const link = event.target.closest?.('a[data-sp-scroll]');
          if (!link || (!this.contains(link) && !link.closest('.sp-steps'))) return;
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          const target = document.getElementById(link.hash.slice(1));
          if (!target) return;
          event.preventDefault();
          target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
          target.focus({ preventScroll: true });
        }, { signal: this.controller.signal });
        this.clock = this.querySelector('[data-countdown]');
        if (!this.clock) return;
        this.digits = this.clock.querySelector('[data-digits]');
        this.expired = this.clock.querySelector('[data-expired]');
        this.units = [...this.clock.querySelectorAll('[data-unit]')];
        const date = this.clock.dataset.launchAt;
        this.target = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(date) ? Date.parse(date) : NaN;
        if (!Number.isFinite(this.target)) {
          this.digits.hidden = true;
          this.expired.hidden = true;
          this.clock.querySelector('[data-date-error]')?.removeAttribute('hidden');
          return;
        }
        try {
          const locale = this.clock.dataset.locale || 'it';
          const day = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Rome', day: 'numeric', month: 'long', year: 'numeric' }).format(this.target);
          const time = new Intl.DateTimeFormat(locale, { timeZone: 'Europe/Rome', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).format(this.target);
          this.clock.querySelector('[data-launch-label]').textContent = `${day} · ${time}`;
        } catch (error) {}
        document.addEventListener('visibilitychange', () => {
          clearTimeout(this.timer);
          if (!document.hidden) this.tick();
        }, { signal: this.controller.signal });
        this.tick();
      }
      tick() {
        const remaining = Math.max(0, Math.ceil((this.target - Date.now()) / 1000));
        const values = { days: Math.floor(remaining / 86400), hours: Math.floor(remaining / 3600) % 24, minutes: Math.floor(remaining / 60) % 60, seconds: remaining % 60 };
        this.units.forEach(unit => { unit.textContent = String(values[unit.dataset.unit]).padStart(2, '0'); });
        this.digits.hidden = remaining === 0;
        this.expired.hidden = remaining > 0;
        if (remaining > 0 && !document.hidden) this.timer = setTimeout(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
